import { render, staticRenderFns } from "./ReportPhysicianFirstAdvance.vue?vue&type=template&id=21e882ce&scoped=true&"
import script from "./ReportPhysicianFirstAdvance.vue?vue&type=script&lang=js&"
export * from "./ReportPhysicianFirstAdvance.vue?vue&type=script&lang=js&"
import style0 from "./ReportPhysicianFirstAdvance.vue?vue&type=style&index=0&id=21e882ce&lang=scss&scoped=true&"
import style1 from "./ReportPhysicianFirstAdvance.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e882ce",
  null
  
)

export default component.exports